/*
 * Globalize Culture hi-IN
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("hi-IN", "default", {
    name: "hi-IN",
    englishName: "Hindi (India)",
    nativeName: "हिंदी (भारत)",
    language: "hi",
    numberFormat: {
      groupSizes: [3, 2],
      percent: {
        groupSizes: [3, 2]
      },
      currency: {
        pattern: ["$ -n", "$ n"],
        groupSizes: [3, 2],
        symbol: "रु"
      }
    },
    calendars: {
      standard: {
        "/": "-",
        firstDay: 1,
        days: {
          names: [
            "रविवार",
            "सोमवार",
            "मंगलवार",
            "बुधवार",
            "गुरुवार",
            "शुक्रवार",
            "शनिवार"
          ],
          namesAbbr: [
            "रवि.",
            "सोम.",
            "मंगल.",
            "बुध.",
            "गुरु.",
            "शुक्र.",
            "शनि."
          ],
          namesShort: ["र", "स", "म", "ब", "ग", "श", "श"]
        },
        months: {
          names: [
            "जनवरी",
            "फरवरी",
            "मार्च",
            "अप्रैल",
            "मई",
            "जून",
            "जुलाई",
            "अगस्त",
            "सितम्बर",
            "अक्तूबर",
            "नवम्बर",
            "दिसम्बर",
            ""
          ],
          namesAbbr: [
            "जनवरी",
            "फरवरी",
            "मार्च",
            "अप्रैल",
            "मई",
            "जून",
            "जुलाई",
            "अगस्त",
            "सितम्बर",
            "अक्तूबर",
            "नवम्बर",
            "दिसम्बर",
            ""
          ]
        },
        AM: ["पूर्वाह्न", "पूर्वाह्न", "पूर्वाह्न"],
        PM: ["अपराह्न", "अपराह्न", "अपराह्न"],
        patterns: {
          d: "dd-MM-yyyy",
          D: "dd MMMM yyyy",
          t: "HH:mm",
          T: "HH:mm:ss",
          f: "dd MMMM yyyy HH:mm",
          F: "dd MMMM yyyy HH:mm:ss",
          M: "dd MMMM"
        }
      }
    },
    messages: {
      Add: "जोड़ना",
      AdditionalHelp: "अतिरिक्त सहायता",
      AddNewTab: "नए टैब जोड़ें",
      Alerts: "अलर्ट",
      ApplyFilter: "फ़िल्टर लागू करें",
      Approve: "स्वीकृत करें",
      AttachmentRules: "अनुलग्नक नियम",
      Attachments: "संलग्नक",
      AutoRefresh: "ऑटो ताज़ा",
      Available: "उपलब्ध है:",
      Back: "वापस",
      BarChart: "पट्टी चार्ट",
      Basic: "बुनियादी",
      Between: "के बीच",
      Book: "किताब",
      Cancel: "रद्द करें",
      CannotBeSelected: "इस पंक्ति का चयन नहीं किया जा सकता.",
      Checked: "जाँच की",
      Clear: "साफ़",
      ClearFilter: "फ़िल्टर साफ़",
      Close: "बंद करें",
      CloseAllTabs: "सभी टैब बंद",
      CloseCancelChanges: "बंद करें और परिवर्तनों को निरस्त करें",
      CloseOtherTabs: "अन्य टैब बंद करें",
      CloseSaveChanges: "बंद करें और परिवर्तन सहेजें",
      CloseTab: "टैब बंद करें",
      ColumnPersonalization: "स्तंभ निजीकरण",
      Comments: "टिप्पणियां",
      Company: "कंपनी",
      Confirmation: "पुष्टि",
      Contains: "होता है",
      CopyMail: "कॉपी और मेल",
      CopyUrl: "कॉपी यूआरएल",
      CreateTab: "एक नया टैब बनाएँ",
      Cut: "कटौती",
      Delete: "हटाना",
      DiscardUndo: "छोड़ना",
      DisplayDropDownList: "ड्रापडाउन सूची प्रदर्शित",
      Displaying: "प्रदर्शित हो रहे हैं:",
      DistributeHorizontally: "क्षैतिज रूप से वितरित करें",
      DocWord: "दस्तावेज़",
      DoesNotContain: "शामिल नहीं है",
      DoesNotEndWith: "साथ अंत नहीं है",
      DoesNotEqual: "बराबर नहीं",
      DoesNotStartWith: "के साथ शुरू नहीं करता है",
      DontHaveAccount: "एक खाता नहीं है?",
      Download: "डाउनलोड",
      DrillDown: "नीचे ड्रिल",
      Duplicate: "प्रतिलिपि",
      Edit: "संपादित करें",
      EitherSelectedorNotSelected: "या तो चयनित या चयनित नहीं",
      Email: "ईमेल",
      EmailValidation: "एक मान्य ईमेल पता दर्ज करें",
      EndofResults: "परिणाम का अंत",
      EndsWith: "के साथ समाप्त होता है",
      Environment: "वातावरण",
      EqualsStr: "बराबरी",
      ExpandAll: "सभी का विस्तार करें",
      ExpandCollapse: "संकुचित / विस्तार",
      ExportFailed: "निर्यात में विफल",
      ExportToExcel: "एक्सेल में निर्यात करें",
      FileInUse: "निर्दिष्ट फ़ाइल उपयोग में है",
      FileInUseDetail:
        "यह प्रयोग में है जहां आवेदन में फाइल को बंद या एक अलग फ़ाइल नाम निर्दिष्ट करें.",
      Filter: "फ़िल्टर",
      FilterMenu: "फ़िल्टर मेनू",
      FilterOptions: "फ़िल्टर विकल्प",
      FilterWithinResults: "परिणामों के दायरे फ़िल्टर",
      Finish: "अंत",
      First: "पहले",
      FirstView: "सबसे पहले देखें",
      Folder: "फोल्डर",
      ForgotPassword: "अपना पासवर्ड भूल गए?",
      Forward: "आगे",
      Generate: "उत्पन्न",
      GenerateScript: "स्क्रिप्ट उत्पन्न",
      GetMoreRows: "अधिक पंक्तियाँ जाओ",
      GreaterThan: "से अधिक",
      GreaterThanOrEquals: "से अधिक या बराबर",
      GridSettings: "ग्रिड सेटिंग्स",
      GroupSelection: "समूह चयन",
      Help: "मदद",
      HideColumn: "कॉलम को छुपाएं",
      IsEmpty: "खाली है",
      IsNotEmpty: "खाली नहीं है",
      Last: "अंतिम",
      LastView: "अंतिम दृश्य",
      LastYear: "अंतिम वर्ष",
      LaunchActivate: "सक्रिय",
      LessThan: "से कम",
      LessThanOrEquals: "से कम या बराबर",
      Links: "लिंक",
      ListAllMenuItems: "सभी मेनू आइटम की सूची बनाएं",
      ListTabs: "सभी टैब्स की सूची बनाएं",
      Loading: "लोड हो रहा है ...",
      LoadingItem: "आइटम लोड हो रहा है",
      Maintenance: "रखरखाव",
      Maximize: "अधिकतम करें",
      Menu: "मेनू",
      Minimize: "छोटा करें",
      More: "और ...",
      MoveDown: "नीचे ले जाएँ",
      MoveUp: "ऊपर ले जाएँ",
      New: "नया",
      NewNode: "नई नोड",
      Next: "अगला",
      NextMonth: "अगले महीने",
      NextView: "अगला दृश्य",
      NextWeek: "अगले हफ्ते",
      NextYear: "अगले साल",
      No: "नहीं",
      NoAttachments: "कोई अनुलग्नक",
      NoRecordsFound: "कोई रिकार्ड नहीं मिला",
      NotChecked: "जाँच नहीं",
      Notes: "नोट्स",
      NotSelected: "चयनित नहीं",
      Of: "की",
      Ok: "अच्छा",
      OneMonthAgo: "एक महीने पहले",
      OneWeekAgo: "एक सप्ताह पहले",
      Open: "खुला",
      Page: "पेज",
      Password: "पासवर्ड",
      Paste: "चिपकाएं",
      Phone: "फ़ोन",
      PieChart: "पाइ चार्ट",
      PleaseWait: "कृपया प्रतीक्षा करें",
      Previous: "पिछला",
      PreviousView: "पिछला देखें",
      Print: "प्रिंट",
      Queries: "प्रश्न",
      QuickAccess: "त्वरित पहुँच",
      QuickDates: "त्वरित तिथियां",
      RecordsPerPage: "पृष्ठ की यादें",
      Redo: "फिर से करना",
      Refresh: "ताज़ा करना",
      Reject: "अस्वीकार",
      RememberMe: "मुझे इस कम्प्यूटर पर याद रखें",
      RememberSettings: "इन सेटिंग्स को याद रखें",
      Remove: "हटाना",
      Reports: "रिपोर्टें",
      Required: "इस फ़ील्ड की आवश्यकता है",
      Reset: "रीसेट करें",
      ResetPassword: "अपना पासवर्ड रीसेट",
      ResetToDefault: "मूलभूत लेआउट को रीसेट",
      RestoreUser: "प्रयोक्ता पुनर्स्थापित",
      Review: "समीक्षा करें",
      Rows: "पंक्तियाँ",
      RunFilter: "फ़िल्टर भागो",
      RunJob: "नौकरी भागो",
      Save: "बचाना",
      SaveBeforeClosing: "समापन से पहले सहेजें",
      SaveConsolidate: "स्थानीय समेकन के साथ सहेजें",
      SavedFilters: "सहेजे गए फ़िल्टर",
      SaveSubmit: "भेजें / सहेजें",
      "Screen Design": "स्क्रीन डिजाइन",
      ScreenDesign: "स्क्रीन डिजाइन",
      Search: "खोज",
      SearchTree: "खोज ट्री",
      SelectAll: "सभी का चयन करें",
      SelectContents: "सामग्री का चयन करें",
      SelectDate: "एक तिथि का चयन करें",
      SelectDeselect: "सभी का चयन करें / अचयनित",
      Selected: "चयनित:",
      SelectMonthYear: "महीना और वर्ष का चयन",
      ServerName: "सर्वर नाम",
      SessionNavigation: "सत्र नेविगेशन",
      SetTextColor: "पाठ रंग सेट",
      Settings: "सेटिंग्स",
      ShowFilterRow: "फ़िल्टर पंक्ति दिखाएँ",
      ShowingAll: "सब दिखा रहा है",
      SignIn: "साइन इन करें",
      SignUpNow: "अब साइन अप करें",
      SixMonthsAgo: "छह महीने पहले",
      SortAscending: "आरोही छँटाई",
      SortDescending: "अवरोही छंटाई",
      SpellCheck: "वर्तनी जाँच",
      Spreadsheet: "स्प्रेडशीट",
      StartsWith: "के साथ शुरू होता है",
      StatusIndicator: "स्थिति सूचक",
      SubmitForApproval: "अनुमोदन के लिए सबमिट करें",
      Tasks: "कार्य",
      Time: "समय",
      Timezone: "समय क्षेत्र",
      Today: "आज",
      Translate: "अनुवाद करना",
      UrlValidation: "लिखें",
      UserID: "यूजर आईडी",
      Utilities: "उपयोगिता",
      Yes: "हां"
    }
  });
})(this);
